import React from 'react';
import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import tools from '../../../tools';
import AlignmentUtils from '../../AlignmentPlugin/AlignmentUtils';

class ToolCellAlign extends Tool {
  static toolName = 'Alignment';
  static submenuTools = () => [
    [tools.ToolAlignLeft, tools.ToolAlignCenter, tools.ToolAlignRight],
    [
      tools.ToolCellVerticalAlignTop,
      tools.ToolCellVerticalAlignMiddle,
      tools.ToolCellVerticalAlignBottom,
    ],
  ];

  static renderToolbarButtonIcon({
    editor,
  }: ToolArgsWithController): JSX.Element {
    let iconClass = 'fa-solid fa-align-left';
    switch (AlignmentUtils.currentAlignment(editor)) {
      case 'center':
        iconClass = 'fa-solid fa-align-center';
        break;
      case 'right':
        iconClass = 'fa-solid fa-align-right';
        break;
      case 'justify':
        iconClass = 'fa-solid fa-align-justify';
        break;
    }

    return <i className={iconClass} />;
  }
}

export default ToolCellAlign;
